import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import GetDynamicLists from '../../Services/Queries/GetDynamicLists'
// import DeleteDynamicList from '../../Services/Mutations/DeleteDynamicList'
import AwsConfig from '../../Config/AwsConfig'
import SearchListsAndCollections from '../../Services/Queries/SearchListsAndCollections'
import UpdateDynamicListStatusService from '../../Services/Mutations/UpdateDynamicListStatusService'
import { DynamiclistInitialValues } from '../Data/StaticPersonandMoviedata'
import AllDynaniclistUi from './AllDynaniclistUi'
import BulkActionsHtml from './BulkActionsHtml'
import ListsDynamicReturn from './ListsDynamicReturn'
import { Auth } from 'aws-amplify'
import GetUserPermissions from '../../Services/Queries/GetUserPermissions'
import { DefinedPermissions } from '../Constants/Permissions'
import { ToastStyle } from '../Data/MovieStaticData'

const ListDynamicListsComponent = () => {
  const [state, setState] = useState(DynamiclistInitialValues)

  const {
    isReadMore,
    onSearchStatus,
    searchInput,
    showLoader,
    dynamicLists,
    nextToken,
    headers,
    checkedArray,
    dynamicListTypes,
    statusTypes,
    selectedListType,
    selectedstatusType,
  } = state
  const [ApproveOptionBoolean, setApproveOptionBoolean] = useState(false)
  const [EDitOptionPermission, setEDitOptionPermission] = useState(false)
  const [DeleteOptionPermission, setDeleteOptionPermission] = useState(false)
  const [BulkActionPermission, setBulkActionPermission] = useState(false)

  const setStateValue = (key, value) => setState(prevState => ({ ...prevState, [key]: value }))
  const checkedArrayChange = (event, value) => {
    const checkedArrayTemp = [...checkedArray]
    if (event.target.checked) {
      checkedArrayTemp.push(value)
      setStateValue('checkedArray', checkedArrayTemp)
    } else {
      const checkedremoved = checkedArrayTemp.filter(e => e.SK !== value.SK)
      setStateValue('checkedArray', checkedremoved)
    }
  }

  const loadMoreLists = async () => {
    const input = {
      limit: 10,
      nextToken,
      status: selectedstatusType,
      dynamicListType: selectedListType,
    }
    try {
      const dynamicListsResponse = await GetDynamicLists(input)
      setStateValue('dynamicLists', [...dynamicLists, ...dynamicListsResponse.items])
      setStateValue('nextToken', dynamicListsResponse.nextToken)
    } catch (error) {
      console.error(error)
    }
  }

  const handleSelectedListType = async listType => {
    setStateValue('selectedListType', listType)
    await getDynamicLists(listType, selectedstatusType)
  }

  const handleSelectedstatusType = async statusType => {
    setStateValue('selectedstatusType', statusType)
    await getDynamicLists(selectedListType, statusType)
  }

  const handleDeleteList = async item => {
    try {
      // const response = await DeleteDynamicList({ PK: item.PK, SK: item.SK })
      // if (response.statusCode === 'A042') {
      //   toast.success(response.statusMessage, ToastStyle)
      //   setStateValue('dynamicLists', dynamicLists.filter(list => list.dynamicListID !== item.dynamicListID))
      // } else {
      //   toast.error('Something went wrong')
      const response = await UpdateDynamicListStatusService({
        dynamicListID: item.dynamicListID,
        status: 'deleted',
      })
      if (response.statusCode === 'M023') {
        toast.success(response.statusMessage, ToastStyle)
        setStateValue(
          'dynamicLists',
          dynamicLists.filter(list => list.dynamicListID !== item.dynamicListID),
        )
      }
    } catch (error) {
      console.error(error)
    }
  }

  const handleApppoveList = async item => {
    try {
      const response = await UpdateDynamicListStatusService({
        dynamicListID: item.dynamicListID,
        status: 'published',
      })

      if (response.statusCode === 'M022') {
        toast.success(response.statusMessage, ToastStyle)
      }

      setStateValue(
        'dynamicLists',
        dynamicLists.filter(list => list.dynamicListID !== item.dynamicListID),
      )
    } catch (error) {
      console.error(error)
    }
  }

  const getDynamicLists = async (listType, statusType) => {
    setStateValue('showLoader', true)
    const input = {
      limit: 10,
      dynamicListType: listType,
      status: statusType,
    }

    try {
      const dynamicListsResponse = await GetDynamicLists(input)

      setStateValue('showLoader', false)
      if (dynamicListsResponse && dynamicListsResponse.items) {
        setStateValue('dynamicLists', dynamicListsResponse.items)
        // get all keys of the first item and set it as headers
        if (dynamicListsResponse.items.length > 0) {
          setStateValue('headers', Object.keys(dynamicListsResponse.items[0]))
        }

        setStateValue('nextToken', dynamicListsResponse.nextToken)
      }
    } catch (error) {
      console.error(error)
    }
  }

  const handleSearchQuery = async e => {
    if (e.target.value.length > 0) {
      setStateValue('onSearchStatus', true)
    } else {
      setStateValue('onSearchStatus', false)
    }

    setStateValue('searchInput', e.target.value)

    const searchQuery = e.target.value
    const searchInput = {
      type: 'dynamicLists',
      search: searchQuery,
      sortBy: 'views',
      sortOrder: 'asc',
      from: 0,
      limit: 10,
    }

    if (searchQuery.length === 0) {
      getDynamicLists(selectedListType, selectedstatusType)
    } else if (searchQuery.length > 0) {
      const searchListsResponse = await SearchListsAndCollections(searchInput)
      setStateValue('dynamicLists', searchListsResponse.items)
    }
  }

  useEffect(() => {
    const getDynamicListsData = async () => {
      await getDynamicLists(selectedListType, selectedstatusType)
    }

    getDynamicListsData()
  }, [])

  let allHeaders = ['S.No', 'Actions', 'CheckBox', ...headers]
  const headersToRemove = ['PK', 'SK', '__typename']
  let tableBodyHeaders = [...headers]

  tableBodyHeaders = tableBodyHeaders.filter(header => !headersToRemove.includes(header))
  allHeaders = allHeaders.filter(header => !headersToRemove.includes(header))

  const renderTableRow = (item, index) => {
    if (item.PK === 'movieLists') {
      item.ID = item.movieListID
      item.dynamicListID = item.movieListID
      item.dynamicListImage = item.movieListImage
    } else if (item.PK === 'dynamicList') {
      item.ID = item.dynamicListID
    } else if (item.PK === 'movieCollection') {
      item.ID = item.movieCollectionID
      item.dynamicListImage = item.movieCollectionImage
      item.dynamicListID = item.movieCollectionID
    }

    let data = item.dynamicListImage

    const editDynamicListId = item && item.ID.replace('dynamicList#', '')

    const getSrcValue = () => {
      if (data === null || data === undefined) {
        data = ''
      }

      if (data.includes('blob:')) {
        data = data.replace(new RegExp(AwsConfig.movieCdnUrl, 'g'), '')
      } else {
        data = data.replace(new RegExp(AwsConfig.movieCdnUrl, 'g'), '')

        if (!data.includes(AwsConfig.movieCdnUrl)) {
          data = AwsConfig.movieCdnUrl + data
        }
      }

      if (!data.includes(AwsConfig.movieCdnUrl)) {
        if (data.includes('blob:')) {
          return data
        }

        return AwsConfig.movieCdnUrl + data
      }

      return data
    }

    const toggleReadMore = () => {
      setStateValue('isReadMore', !isReadMore)
    }

    return (
      <tr key={index}>
        <td>{index + 1}</td>
        <BulkActionsHtml
          onSearchStatus={onSearchStatus}
          handleDeleteList={handleDeleteList}
          editDynamicListId={editDynamicListId}
          item={item}
          handleApppoveList={handleApppoveList}
          selectedstatusType={selectedstatusType}
          ApproveOptionBoolean={ApproveOptionBoolean}
          EDitOptionPermission={EDitOptionPermission}
          DeleteOptionPermission={DeleteOptionPermission}
        />
        <td>
          <input
            checked={Boolean(checkedArray.some(x => x.SK === item.SK))}
            name={item.PK}
            value={item.SK}
            type='checkbox'
            onChange={e => checkedArrayChange(e, item)}
          />
        </td>
        {tableBodyHeaders.map((header, index) => (
          <ListsDynamicReturn
            key={index}
            header={header}
            getSrcValue={getSrcValue}
            isReadMore={isReadMore}
            item={item}
            toggleReadMore={toggleReadMore}
          />
        ))}
      </tr>
    )
  }

  useEffect(() => {
    const getPermissions = async () => {
      const permissionInput = { mobileNumber: Auth.user.attributes.phone_number }
      const userPermissions = await GetUserPermissions(permissionInput)
      const permissionsArray =
        userPermissions?.userRolesAndPermissions?.reduce(
          (flattenedPermissions, role) => [
            ...flattenedPermissions,
            ...role.permissions.map(permission => permission.name),
          ],
          [],
        ) || []

      setApproveOptionBoolean(permissionsArray.includes(DefinedPermissions.DynamicListApprove))

      setEDitOptionPermission(permissionsArray.includes(DefinedPermissions.DynamicListEdit))
      setDeleteOptionPermission(permissionsArray.includes(DefinedPermissions.DynamicListDelete))
      setBulkActionPermission(permissionsArray.includes(DefinedPermissions.DynamicListBulkActions))
    }

    getPermissions()
  }, [])
  return (
    <AllDynaniclistUi
      showLoader={showLoader}
      searchInput={searchInput}
      onSearchStatus={onSearchStatus}
      handleSearchQuery={handleSearchQuery}
      statusTypes={statusTypes}
      handleSelectedstatusType={handleSelectedstatusType}
      dynamicListTypes={dynamicListTypes}
      selectedstatusType={selectedstatusType}
      handleSelectedListType={handleSelectedListType}
      selectedListType={selectedListType}
      checkedArray={checkedArray}
      dynamicLists={dynamicLists}
      allHeaders={allHeaders}
      renderTableRow={renderTableRow}
      nextToken={nextToken}
      loadMoreLists={loadMoreLists}
      setStateValue={setStateValue}
      BulkActionPermission={BulkActionPermission}
    />
  )
}

export default ListDynamicListsComponent
